import ReceiptTextSvg from '@assets/images/svg/receipt-text.svg';
import React from 'react';
import { View } from 'react-native';

export interface ReceiptTextIconProps {
    size?: number;
    color?: string;
}

export const ReceiptTextIcon = React.memo<ReceiptTextIconProps>(function ReceiptTextIcon({
    size = 18,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ReceiptTextSvg width={size} height={size} color={color} />
        </View>
    );
});

export default ReceiptTextIcon;
